// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/spannfeder/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const spannfederDE: PageEntry = {
  id: "post.spannfeder",
  locale: "de",
  slug: "spannfeder",
  seo: {
    title: "Glossar: Spannfeder einfach erklärt | Dietz GmbH",
    description: "Spannfedern sind Federn, die dazu dienen, Bauteile oder Elemente zusammenzuziehen oder zu spannen. Diese Federn werden häufig in Kombination mit anderen Mechanismen verwendet, um e",
  },
  type: "post",
  h1: "Glossar: Spannfeder einfach erklärt",
  intro: "Spannfedern sind Federn, die dazu dienen, Bauteile oder Elemente zusammenzuziehen oder zu spannen. Diese Federn werden häufig in Kombination mit anderen Mechanismen verwendet, um eine mechanische Vorspannung zu erzeugen. Spannfedern finden Anwendung in verschiedenen Bereichen, von industriellen Maschinen bis zu Werkzeugen und Vorrichtungen. Durch ihre Fähigkeit, Zugkräfte aufzunehmen und zu übertragen, tragen Spannfedern dazu bei, die Stabilität von Baugruppen zu gewährleisten. Bei der Auswahl von Spannfedern sind Faktoren wie Federkonstante, Materialwahl und geometrische Eigenschaften entscheidend.",
  blocks: [

  ],
};
